export interface ThemeState {
  sidebarVisible: boolean;
  sidebarUnfoldable: boolean;
}

export default {
  namespaced: true,
  state: {
    sidebarVisible: true,
    sidebarUnfoldable: false,
  } as ThemeState,
  mutations: {
    toggleSidebar(state: ThemeState) {
      state.sidebarVisible = !state.sidebarVisible;
    },
    toggleUnfoldable(state: ThemeState) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable;
    },
    updateSidebarVisible(state: ThemeState, value: boolean) {
      state.sidebarVisible = value;
    },
  },
  actions: {},
};
